import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../../utils/api';
import BackButton from '../../components/BackButton';

const ClientNotes = () => {
  const { id } = useParams(); // clientId
  const token = localStorage.getItem('token');
  const [notes, setNotes] = useState([]);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/notes/client/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setNotes(res.data);
      } catch (err) {
        alert('Error loading notes');
      }
    };

    fetchNotes();
  }, [id, token]);

  const toggleSelect = (noteId) => {
    setSelected(prev =>
      prev.includes(noteId) ? prev.filter(id => id !== noteId) : [...prev, noteId]
    );
  };

  const exportNotes = async (mode = 'selected') => {
    try {
      const payload =
        mode === 'all' ? { clientId: id } : { noteIds: selected };

      const res = await axios.post(
        `${API_BASE_URL}/api/pdf/export`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: 'blob',
        }
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = `ShiftNotes_${mode}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (err) {
      alert('Failed to export PDF');
    }
  };

  return (
    <div className="min-h-screen bg-[#0E0A1F] text-white p-6">
      <BackButton/>
      <div className="max-w-3xl mx-auto space-y-6">
        <h2 className="text-2xl font-bold mb-2">Shift Notes</h2>

        {notes.length > 0 && (
          <div className="flex justify-end gap-4 mb-4">
            <button
              onClick={() => exportNotes('selected')}
              disabled={selected.length === 0}
              className={`px-4 py-2 rounded ${
                selected.length === 0 ? 'bg-gray-600 cursor-not-allowed' : 'bg-[#8F4EFF] hover:bg-purple-700'
              }`}
            >
              Export Selected ({selected.length})
            </button>
            <button
              onClick={() => exportNotes('all')}
              className="bg-[#8F4EFF] hover:bg-purple-700 px-4 py-2 rounded"
            >
              Export All
            </button>
          </div>
        )}

        {notes.length === 0 ? (
          <p className="text-gray-400">No notes available.</p>
        ) : (
          notes.map(note => (
            <div key={note.id} className="bg-[#1C1235] p-4 rounded-xl shadow space-y-2 relative">
              <input
                type="checkbox"
                className="absolute top-4 right-4 w-4 h-4"
                checked={selected.includes(note.id)}
                onChange={() => toggleSelect(note.id)}
              />

              <div className="flex justify-between text-sm text-gray-400">
                <span>{note.date} | {note.startTime} - {note.endTime}</span>
                <span>{new Date(note.createdAt).toLocaleString()}</span>
              </div>
              <p className="text-white">{note.content.slice(0, 150)}...</p>

              {note.photo && (
                <img
                  src={`http://localhost:5000${note.photo}`}
                  alt="Note"
                  className="w-24 h-24 mt-2 rounded border border-gray-600 object-cover"
                />
              )}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ClientNotes;
